import { useMemo } from 'react'
import { documentationRootGuid } from '@constants'
import { Stack } from '@mui/material'
import { Form2 } from '@ui/forms'
import BaseFormFields from '../BaseFormFields'

type DefaultValues = FileItemConfig | FolderItemConfig

interface Props {
  item: FileItem | SectionItem
  mutate: (data: FileItemConfig | FolderItemConfig) => void
}

const NoPropertiesForm = ({ item, mutate }: Props) => {
  const defaultValues = useMemo(() => {
    return {
      ...item.additional_data,
      item_guid: item.guid,
      name: item.name,
    }
  }, [item])

  return (
    <Stack spacing={2} p={1}>
      <Form2
        key={JSON.stringify(defaultValues)}
        onSubmit={(data: DefaultValues) => {
          mutate(data)
        }}
        defaultValues={defaultValues}
        submitOnChange
      >
        <BaseFormFields
          elementGuid={'element_guid' in item ? item.element_guid : undefined}
          showBeginOnNewPage={item.parent_guid !== documentationRootGuid}
        />
      </Form2>
    </Stack>
  )
}

export default NoPropertiesForm
